import EditOutletCategory from "./Edit";

export default function AddOutletCategory() {
    return <EditOutletCategory mode="add" />;
}
